import type { GridState, UnmappedGridState } from './types'

export const mapGridState: GridState = (datum: UnmappedGridState) => {
	if (!datum) return
	const state = datum.State ? JSON.parse(datum.State) : {}
	return {
		...state
	}
}